/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { isEmpty, forEach } from "lodash-es";
import {
  getBankAccountList,
  getBankTransRecordList,
  sendBankTransRecordsPush,
} from "../../../apis/finances/bank";
import BankTable from "../../../components/Bank/BankTable";
import Filters from "../../../components/Filters";
import NoData from "../../../components/NoData/NoData";
import { getDay } from "../../../utils/date";
import { cloneDeep, get, trim } from "lodash";
import Icon from "../../../components/Icon";
import Badge from "../../../components/Badge";
import { BANK_DATA, BANK_TYPE } from "../../../constants/BANK_DATA";
import { translation } from "../../../utils/translator";
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png";
import useForm from "../../../hooks/useForm";
import { HashLink as Link } from "react-router-hash-link";
import PageHeader from "../../../components/PageHeader";
import systemAlert from "../../../utils/systemAlert";
import { shallowEqual, useSelector } from "react-redux";
import { toast } from "../../../utils/toast";


const BankAccountByUseConfirmList = (props) => {
  const { history, permission, activeTab, tabList } = props;
  const [bankList, setBankList] = useState([]);
  const [filterBankList, setFilterBankList] = useState([]);
  const [type] = useState("normal_account");
  const [params, setParams] = useState({});
  const [filters, setFilters] = useState([]);
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );

  useEffect(() => {
    // 계좌 필터 세팅
    const setAccountFilter = async () => {
      const res = await getBankAccountList(false, type);
      /*
      setFilterBankList(res.data.bankAccounts.map((bank) => ({
        ...bank,
        bankCompany: translation(BANK_DATA, bank.bankCd, "fcode", "name"),
      })));
      */

      // 계좌선택 - 사용중 계좌만 포함
      if (!isEmpty(res.data.bankAccounts)) {
        var list = [];
        forEach(res.data.bankAccounts, (bank) => {
          if (bank.status === "enabled") {
            list.push({
              ...bank,
              bankCompany: translation(BANK_DATA, bank.bankCd, "fcode", "name"),
            });
          }
        });
        setFilterBankList(list);
      } else {
        setFilterBankList([]);
      }
    };
    setAccountFilter();
  }, []);

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    filterSubmit,
    setValidateFields,
  } = useForm(
    {
      search: {
        clientName: "",
        traderName: ""
      },
      order: [
        {
          tradeTime: "desc",
        },
        {
          idx: "desc",
        },
      ],
      range: {
        tradeTime: isEmpty(get(history, 'location.state')) ? [getDay(700), getDay()] : get(history, 'location.state.date'),
      },
      // clientRegistered: clientRegistered ? true : false,
      clientRegistered: false,
      bankAccountIdx: String(get(history, 'location.state.data.idx')) || null
    }
  );

  useEffect(() => {
    if (!isEmpty(filterBankList)) {
      const fields = [
        // {
        //   title: "조회기간",
        //   type: "customdatepicker",
        //   key: "range.tradeTime",
        // },
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...filterBankList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
        {
          title: "거래처명 검색",
          key: "search.clientName",
          placeholder: '거래처명 입력'
        },
        {
          title: "거래처 등록여부",
          type: "checkbox",
          key: "clientRegistered",
          label: "미등록만 보기",
          checked: form.clientRegistered,
          onChange: (check) => {
            setForm({
              ...form,
              clientRegistered: check
            });
          },
        },
      ];
      setFilters(fields);
      setValidateFields(fields);
    }
  }, [filterBankList, form]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  const submit = (params) => {
    const _params = cloneDeep(params);

    if (!isEmpty(_params.bankAccountIdx)) {
      _params.bankAccountIdx = Number(_params.bankAccountIdx);
    } else {
      delete _params.bankAccountIdx;
    }
    setParams(_params);

    getBankAccountList(false, type, _params.bankAccountIdx || null, 'enabled')
      .then((res) => {
        const bankAccountList = res.data.bankAccounts.map((bank) => ({
          ...bank,
          bankCompany: translation(BANK_DATA, bank.bankCd, "fcode", "name"),
          bankImg: translation(
            BANK_DATA,
            bank.bankCd,
            "fcode",
            "bankImg"
          ),
        }));

        setBankList(bankAccountList);
      })
      .catch(() => { })
      .finally(() => { });
  };



  const headerButtons = [{
    label: '확인요청 보내기',
    action: () => {
      // companyIdx 추출하기

      systemAlert("대표관리자 및 경리업무 담당자에게 확인요청 알림을 보내시겠습니까?", {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              sendBankTransRecordsPush({ companyIdx: user.companyIdx }).then(res => {
                toast.success("확인요청 알림 전송이 완료되었습니다.");
              });
            }
          }
        ]
      });
    }


  }];


  return (
    <>
      <PageHeader
        title={"내역확인 요청목록"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      {!isEmpty(filterBankList) && (
        <Filters
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
      )}
      {!isEmpty(bankList) ? (
        bankList.map((bank, idx) => (
          <BankTable
            key={idx}
            bankList={bankList}
            bankAccountIdx={bank.idx}
            isUseConfirm={true}
            title={() => {
              return (
                <div>
                  <Icon className="bank-img-wrap" src={bank.bankImg || defaultBankImage} alt={bank.bankCompany} />
                  <Badge
                    className="margin-left-8"
                    color={bank.orgCd === 'pbk' ? "secondary" : 'warning'}
                    size="sm"
                    label={translation(BANK_TYPE, bank.orgCd)}
                  />
                  <span className="margin-left-8">
                    {`${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`}

                    {!isEmpty(bank.nickName) && trim(String(bank.nickName)) !== "" &&
                      `-[${trim(String(bank.nickName))}]`
                    }

                  </span>
                </div>
              );
            }}
            api={getBankTransRecordList}
            params={params}
            permission={permission}
          />
        ))
      )
        : <NoData text={
          <Link to="/manager/financial?tab=auto-scrapping#section-one" className="text-align-center">
            <p className="color-gray-5 nowrap">
              {"관리자 > 금융 정보 자동 수집 > 은행 계좌 정보를 연동해주세요."}
            </p>
            <p className="color-main-80 font-size-15">
              {"클릭시 해당 메뉴로 이동합니다."}
            </p>
          </Link>
        } />
      }
    </>
  );
};

export default BankAccountByUseConfirmList;